<template>
  <div class="search-layout zpa-column" :class="className">
    <div class="zpa-row top middle" style="flex: none; padding: 0;">
      <slot name="search"></slot>
    </div>
    <div class="zpa-column bottom" :class="{'no-border': noBottomBorder}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchLayout',

  props: {
    noGutter: Boolean,

    split: {
      type: Boolean,
      default: true,
    },

    noBottomBorder: Boolean,
  },

  computed: {
    className() {
      return {
        'no-gutter': this.noGutter,
        'no-split': !this.split,
      }
    },
  },
}
</script>
<style>
.ivu-modal-fullscreen .ivu-modal-body {
  overflow-x: hidden;
}
</style>
<style scoped lang="less">
.search-layout {
  max-width: 100%;
  height: 100%;

  .top {
    margin-bottom: 8px;
    z-index: 9;
  }

  .bottom {
    overflow: auto;
    padding: 8px;

    &.no-border {
      padding: 0;
      border: none;
    }
  }

  .top,
  .bottom {
    max-width: 100%;
    background: #fff;
    border-radius: 2px;
    border: 1px solid #dcdee2;
  }

  &.no-split {
    padding: 12px;
    background: #fff;

    .top {
      margin-bottom: 0;
      padding-bottom: 0;
    }

    .bottom {
      padding-top: 0;
    }

    .top,
    .bottom {
      background: transparent;
      border: none;
    }
  }
}
</style>
